import { useState } from "react";
import { Link } from "react-router-dom";
import { Logo, CtaButton, MonoLabel } from "../components/kit";
import api, { formatApiErrorDetail } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen dot-grid flex flex-col" data-testid="forgot-password-page">
      <div className="max-w-6xl w-full mx-auto px-6 py-6">
        <Link to="/"><Logo className="h-5 sm:h-6" /></Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-4 pb-24">
        <div className="w-full max-w-md card-soft p-8 sm:p-10 fade-up">
          <MonoLabel>RESET PASSWORD</MonoLabel>
          <h1 className="mt-5 text-2xl sm:text-3xl leading-tight">
            <span className="font-serif-it block">Forgot your password?</span>
            <span className="font-extrabold tracking-[-0.02em] block">Happens to the best</span>
          </h1>
          {sent ? (
            <div className="mt-6" data-testid="forgot-password-sent">
              <p className="text-[14px] text-[#181621] bg-[#EEF6EF] rounded-lg px-4 py-3.5 leading-relaxed">
                If an account exists for this email, we've sent a link to reset your password. Check your inbox (and spam) — the link is valid for 1 hour.
              </p>
              <Link to="/auth" className="block text-center text-[13.5px] font-semibold text-[#181621] underline underline-offset-2 mt-6" data-testid="forgot-back-to-login">
                Back to login
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="font-mono-j text-[10px] tracking-[0.12em] text-[#54505B] uppercase block mb-1.5">Email</label>
                <input className="field-input" type="email" placeholder="you@business.com" value={email}
                       onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" />
              </div>
              {error && (
                <p className="text-[13px] text-[#B4443C] bg-[#FBE9E7] rounded-lg px-3.5 py-2.5" data-testid="forgot-error-message">{error}</p>
              )}
              <CtaButton type="submit" className="w-full mt-2" disabled={busy} data-testid="forgot-submit-btn">
                {busy ? "One moment…" : "Send me the reset link"}
              </CtaButton>
              <Link to="/auth" className="block text-center text-[13.5px] text-[#54505B] underline underline-offset-2" data-testid="forgot-cancel-link">
                Back to login
              </Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
